export default __webpack_public_path__ + "static/media/warning-icon.3bfd6a5a.svg";